module.exports = __webpack_public_path__ + "frontend/images/faq/screen-add-cards-7496f7d0cafcaa75c174924729e195a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-add-cards.jpg
// module id = 339
// module chunks = 2